import { useEffect, useState } from 'react';

const ScreenOrientationLandscape = ['landscape-primary', 'landscape-secondary'];

const isLandscapeOrientation = () => {
  if (window.screen.orientation) {
    return ScreenOrientationLandscape.includes(window.screen.orientation.type);
  }
  return window.innerWidth > window.innerHeight;
};

export const useLandscapeDetection = () => {
  const [isLandscape, setIsLandscape] = useState(isLandscapeOrientation());

  useEffect(() => {
    const updateLandscapeState = () => {
      setIsLandscape(isLandscapeOrientation());
    };

    if (window.screen.orientation) {
      window.screen.orientation.addEventListener('change', updateLandscapeState);
    } else {
      window.addEventListener('resize', updateLandscapeState);
    }

    return () => {
      if (window.screen.orientation) {
        window.screen.orientation.removeEventListener('change', updateLandscapeState);
      } else {
        window.removeEventListener('resize', updateLandscapeState);
      }
    };
  }, []);

  return isLandscape;
};
